<template>
  <main role="main" class="container-fluid">
    <!-- Tíitulo da Section -->
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2"
    >
      <!-- @slot customiza o Titulo  -->
      <slot name="titulo"
        ><h1 class="h2 title-section">{{ $t(titulo) }}</h1></slot
      >
      <div>
        <!-- @slot customiza o Titulo extra  -->
        <slot name="titulo-extra"> </slot>
      </div>
    </div>
    <!-- / Tíitulo da Section -->
    <div class="card mb-4">
      <!-- @slot Conteudo -->
      <slot></slot>
    </div>
  </main>
</template>
<script>
/**
 * Rederiza uma tag main com titulo e body
 */
export default {
  name: "HcMain",
  props: {
    /**
     * Titulo deste bloco
     */
    titulo: {
      type: String
    }
  }
};
</script>
